<template>
	<div id="quote-summary-template">
		<appCreateProgressBar />
		<div class="container">	
				Review Quote &amp; Review
		</div>
	</div>
</template>

<script>

import CreateProgressBar from '../common/Create/CreateProgressBar';
export default {
	components : {
		appCreateProgressBar : CreateProgressBar
	},
	data(){
		return {
			

		}
	},

}
</script>



// WEBPACK FOOTER //
// src/components/pages/QuoteReview.vue